import { FC } from 'react';
import { Trans } from 'base/utils/i18n';
import { LoopRender } from '@base/snippets/LoopRender';
import Image from '@base/lib/ThemeImage';
import cn from 'classnames';
import { isPhone } from 'base/utils/client';

type IProps = {
    className?: string;
};

const list = [
    {
        icon: 'asset/width-709/picture/7ba17fd3b030d761994e592a053c92db.png',
        text: 'web_footer_support_1',
    },
    {
        icon: 'asset/width-709/picture/b7a1c745389a652878a7fdb07ee13d63.png',
        text: 'web_footer_support_2',
    },
    {
        icon: 'asset/width-709/picture/50c2679edf2001237dad6955d5b03025.png',
        text: 'web_footer_support_3',
    },
    {
        icon: 'asset/width-709/picture/ea80e2c4cbeadbcf6582f3c4eafa365a.png',
        text: 'web_footer_support_4',
    },
    {
        icon: 'asset/width-709/picture/b10710820750c846acf872aa31c327fc.png',
        text: 'web_footer_support_5',
    },
];

export const FooterSupport: FC<IProps> = ({ className }) => {
    return (
        <LoopRender
            className={className}
            list={list}
            render={item => (
                <div className={cn('g-item')}>
                    <Image
                        width={isPhone ? 32 : 48}
                        src={item.icon}
                        fixed
                        background={false}
                    />

                    <div className={'g-text'}>
                        <Trans
                            i18nKey={item.text}
                            components={{
                                span: <span className="text-primary"/>,
                                br: isPhone ? ' ' : <br/>
                            }}
                        />
                    </div>
                </div>
            )}
        />
    )
};
